<template lang="pug">
  .user-list
    h2.primary--text Benutzer-Liste

    v-row.align-center.mt-4
      v-col(cols="6")
        v-text-field.pt-0(
          v-model="search"
          append-icon="search"
          placeholder="Suchen"
          outlined
          single-line
          hide-details
        )

      v-col.text-right(cols="6")
        v-btn(color="primary" @click="gotoRoute('user-add')") + Neue Benutzer

    v-data-table.mt-3(
      v-bind="tableProps"
      :headers="headers"
      :items="users"
      :search="search"
      :options="defaultPagination"
    )
      tr(
        slot="item"
        slot-scope="{ item }"
        :style="{ 'background-color': (item.disabled ? '#FCE4EC' : 'white') }"
      )
        td.text-left {{ item.forename }} {{ item.lastname }}
        td.text-left {{ item.user_group }}
        td.text-left {{ item.email }}
        td.text-center {{ item.disabled ? 'Ja' : 'Nein' }}

        td.text-right
          a.mr-1(title="Benutzer bearbeiten" @click.prevent="onEditUser(item)")
            i.fo.fo-large.fo-pencil

      template(#footer.page-text="{ pageStart, pageStop }")
        span Von {{ pageStart }} bis {{ pageStop }}

</template>

<script>
import { Vue, Component } from 'vue-property-decorator'

import FormMixin from '@/mixins/form'
import Urls from '@/router/urls'

@Component({
  mixins: [
    FormMixin
  ],
})
export default class UserList extends Vue {
  users = []
  search = ''

  headers = [
    {
      text: 'Name',
      align: 'left',
      sortable: true,
      value: 'name'
    },
    {
      text: 'Gruppe',
      align: 'left',
      sortable: true,
      value: 'user_group'
    },
    {
      text: 'E-Mail',
      align: 'left',
      sortable: true,
      value: 'email'
    },
    {
      text: 'Deaktiviert',
      align: 'center',
      sortable: false,
      value: 'disabled'
    },
    {
      text: 'Aktion',
      align: 'right',
      sortable: false,
      value: '#'
    },
  ]

  created () {
    this.loadUsers()
  }

  loadUsers () {
    this.$axios
      .get(Urls.AdminUser())
      .then(res => {
        this.users = res.data || []
      })
  }

  onEditUser (item) {
    this.$router.push({
      name: 'user-edit',
      params: {
        id: item.id
      }
    })
  }
}
</script>
